const ranking = [
  { rank: 1, title: '某顶流男星恋情曝光后续：工作室深夜发声明', heat: '热度 9.8', change: 'new' },
  { rank: 2, title: '综艺录制事故追踪：节目组正式道歉', heat: '热度 9.5', change: 'up' },
  { rank: 3, title: '品牌代言风云：双方解约内幕全揭秘', heat: '热度 9.1', change: 'up' },
  { rank: 4, title: '年度热门剧集大结局引发全网狂欢', heat: '热度 8.7', change: 'down' },
  { rank: 5, title: '网红直播间口误事件持续发酵', heat: '热度 8.3', change: 'same' },
  { rank: 6, title: '知名导演新片阵容首次全曝光', heat: '热度 7.9', change: 'up' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热度榜单
          </h2>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {ranking.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < ranking.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer group`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-100 text-foreground-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors truncate whitespace-nowrap">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                <span className="flex-shrink-0">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-primary-100 text-primary-600 whitespace-nowrap">NEW</span>
                  )}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}